import { trans } from "@mongez/localization";
import emptyCart from "~/assets/images/empty/cart.png";
import { BaseLink } from "~/design-system/components";
import { cartDrawerAtom } from "~/modules/shared/atoms";
import { URLS } from "~/shared/urls";

export function CartDrawerEmptyState() {
  return (
    <div className="container my-auto flex h-full max-w-full flex-col items-center justify-center gap-2 sm:max-w-[430px]">
      <img src={emptyCart} alt="empty cart" className="size-[105px]" />
      <h2 className="font-playfair text-base font-bold text-[#0A0A0A] sm:text-lg lg:text-xl">
        {trans("cart.emptyTitle")}
      </h2>
      <p className="font-avenir max-w-[318px] text-center text-sm font-medium text-[#414141]/50 sm:text-base lg:text-lg">
        {trans("cart.emptySubtitle")}
      </p>

      <BaseLink
        to={URLS.ourCakes.list}
        onClick={cartDrawerAtom.close}
        className="bg-primary-light hover:bg-primary-600 mt-6 h-auto justify-center rounded-full border border-black px-8 py-4 transition-colors duration-300"
      >
        {trans("continueShopping")}
      </BaseLink>
    </div>
  );
}
